import { lazyLoad } from "./LazyLoad";
const DATA_PIC_ATTR = "data-pic-cms-src";
const DATA_PIC_SRCSET = "data-pic-cms-srcset";
const initPicturesFunctionality = function () {
  let pictures = document.querySelectorAll(`[${DATA_PIC_ATTR}]`);
  for (let i = 0, len = pictures.length; i < len; i += 1) {
    let item = pictures[i];
    item.onload = function () {
      // https://jira.dev.fb/browse/CMSB-3273
      this.setAttribute("data-cms-image-lazy-loaded", "true");
    };

    // Intersection observer doesn't work with elements with applied css 'transform' prop.
    // so we remove it in order for the observer to detect element change.
    let cachedTransform = item.style.transform;
    item.style.transform = "none";
    lazyLoad(item, target => {
      if (target.parentElement.tagName === "PICTURE") {
        let parent = target.parentElement;
        let sourcetags = parent.querySelectorAll(`[${DATA_PIC_SRCSET}]`);
        for (let i = 0, len = sourcetags.length; i < len; i += 1) {
          let sourceTag = sourcetags[i];
          sourceTag.setAttribute("srcset", sourceTag.getAttribute(DATA_PIC_SRCSET));
        }
      }
      target.setAttribute("src", target.getAttribute(DATA_PIC_ATTR));

      // when the observer make the element visible, return its transform prop.
      target.style.transform = cachedTransform;
    });
  }
};
const initPicturesFunctionalityInContext = function (context) {
  let pictures = context.querySelectorAll(`[${DATA_PIC_ATTR}]`);
  for (let i = 0, len = pictures.length; i < len; i += 1) {
    let item = pictures[i];
    lazyLoad(item, target => {
      //target.setAttribute("src", target.getAttribute(DATA_PIC_ATTR));

      if (target.parentElement.tagName === "PICTURE") {
        let parent = target.parentElement;
        let sourcetags = parent.querySelectorAll(`[${DATA_PIC_SRCSET}]`);
        for (let i = 0, len = sourcetags.length; i < len; i += 1) {
          let sourceTag = sourcetags[i];
          sourceTag.setAttribute("srcset", sourceTag.getAttribute(DATA_PIC_SRCSET));
        }
      }
      target.setAttribute("src", target.getAttribute(DATA_PIC_ATTR));
    });
  }
};
export { initPicturesFunctionality, initPicturesFunctionalityInContext };